import { InfoCircleOutlined } from '@ant-design/icons'
import type { IHeaderParams } from 'ag-grid-community'
import { Tooltip } from 'antd'

type HeaderWithTooltipProps = IHeaderParams & {
  tooltip: string
}

export const HeaderWithTooltip = ({
  displayName,
  tooltip,
}: HeaderWithTooltipProps) => (
  <span style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
    {displayName}
    <Tooltip title={tooltip}>
      <InfoCircleOutlined
        style={{ color: 'var(--gray-5)', fontSize: 12, cursor: 'help' }}
      />
    </Tooltip>
  </span>
)
